import { render, staticRenderFns } from "./NoteSecurityIcon.vue?vue&type=template&id=48672f00&"
import script from "./NoteSecurityIcon.vue?vue&type=script&lang=ts&"
export * from "./NoteSecurityIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports